<template>
  <div>
    <banner-top :text="titletext"></banner-top>
    <div class="classNum">
        <img :src="res.thumbnail" alt="">
        <div class="classNumItem">
          <div>{{res.title}}</div>
          <div class="classNumber">
            <span>￥{{res.price}}</span>
            <div class="classNumberItem">
              <img @click="cut" src="../assets/icon24.png" alt="">
              <div> {{number}} </div>
              <img @click="add" src="../assets/icon23.png" alt="">
            </div>
          </div>
        </div>
    </div>
    <div class="centerBg"></div>
    <div class="information">上课信息</div>
    <el-divider></el-divider>
    <div class="info">
      <div class="timetitle">
        <div style="line-height:2.2rem">
          上课日期
        </div>
        <div class="time">
          <div v-bind:key="item.index" v-for="(item, index) in timeDay.dates">
            <div class="placeItem" :class="checked1==index?'checked':''" @click="watch(index, 1)">{{item}}</div>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <div class="timetitle">
          请选择上课时间段
        </div>
        <div class="time">
          <div v-bind:key="item.index" v-for="(item, index) in timeHour.sessions">
            <div class="timeItem" :class="checked2==index?'checked':''" @click="watch(index, 2)">{{item.start}}-{{item.end}}</div>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <div class="timetitle">
          请选择上课地点
        </div>
        <div class="place">
          <div v-bind:key="index" v-for="(item, index) in places.places">
            <div class="placeItem" :class="checked3==index?'checked':''" @click="watch(index, 3)">{{item.name}}</div>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="coursenum">
        <div>课程人数：{{courseSum}}</div>
        <div>剩余数量：{{rest}}</div>
      </div>
    </div>
    <div class="centerBg"></div>
    <div class="information">
      <div class="addStudent">
        <div>学生信息</div>
        <div class="add"><router-link to="/student">添加+</router-link></div>
      </div>
    </div>
    <el-divider></el-divider>
    <div v-for="item in students.students" :key="item.id">
      <div class="student">
        <img @click="del(item.id)" src="../assets/icon28.png" alt="">
        <div style="font-size: 18px;">{{item.name}}</div>
        <div class="content">
          {{item.school}},
          {{item.classroom}}，
          {{item.gender==1?'男': '女'}}，
          联系电话{{item.phone}}，
          身份证号{{item.id_no}}
        </div>
      </div>
    </div>
    <div style="height:3rem"></div>
    <div class="nav">
        <div>合计：</div>
        <span>￥{{sum}}</span>
        <button v-if="this.rest>=this.number" class="navpay" @click="pay">提交</button>
        <button v-else class="navUnpay">提交</button>
    </div>
  </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'
import http from '../utils/http'

export default {
  name: 'booking',
  components: { bannerTop },
  data () {
    return {
      checked1: 0,
      checked2: 0,
      checked3: 0,
      number: 1,
      titletext: '确认订单',
      timeDay: Object,
      timeHour: Object,
      places: Object,
      res: Object,
      students: Object,
      sum: 0,
      rest: 0,
      courseSum: 0
    }
  },
  methods: {
    checked (tem) {
      this.timeCheck = tem
    },
    del (id) {
      this.$confirm('删除该学生信息?', {
        confirmButtonText: '确定',
        cancelButtonText: '我再想想',
        type: 'warning',
        customClass: 'winClass'
      }).then(() => {
        http['delete'](`students/${id}`)
        http['get']('students').then((res) => {
          this.students = res
        })
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    cut () {
      if (this.number > 1) {
        this.number--
      } else {
        this.$message.error('数量不能少于1哦')
      }
      this.sum = parseFloat(this.res.price * this.number).toFixed(2)
    },
    add () {
      if (this.number < this.rest) {
        this.number++
      } else {
        this.$message.error('数量不能超过剩余量哦')
      }
      this.sum = parseFloat(this.res.price * this.number).toFixed(2)
    },
    watch (index, id) {
      if (id === 1) {
        this.checked1 = index
      } else if (id === 2) {
        this.checked2 = index
      } else {
        this.checked3 = index
      }
      http['get'](`lectures/${this.$route.query.id}/availability?date=${this.timeDay.dates[this.checked1]}&session=${this.timeHour.sessions[this.checked2].id}&place=${this.places.places[this.checked3].id}`)
        .then((res) => {
          this.courseSum = res.total
          this.rest = res.rest
        })
    },
    pay () {
      let studentId = []
      for (let i = 0; i < this.students.students.length; i++) {
        studentId.push(this.students.students[i].id)
      }
      let tem = {
        amount: this.number,
        date: this.timeDay.dates[this.checked1],
        session: this.timeHour.sessions[this.checked2].id,
        place: this.places.places[this.checked3].id,
        students: studentId
      }
      http['post'](`lectures/${this.$route.query.id}/order`, tem)
        .then((res) => {
          this.$router.push({name: 'pay', query: {order_no: res.order_no, detail: this.sum, created: res.created}})
        }).catch((err) => {
          this.$message.error(err)
        })
    }
  },
  created () {
    http['get'](`lectures/${this.$route.query.id}`).then((res) => {
      this.res = res
      this.sum = res.price
    })
    http['get'](`lectures/${this.$route.query.id}/dates`).then((res) => {
      this.timeDay = res
      http['get'](`lectures/${this.$route.query.id}/sessions`).then((res) => {
        this.timeHour = res
        http['get'](`lectures/${this.$route.query.id}/places`).then((res) => {
          this.places = res
          http['get'](`lectures/${this.$route.query.id}/availability?date=${this.timeDay.dates[this.checked1]}&session=${this.timeHour.sessions[this.checked2].id}&place=${this.places.places[this.checked3].id}`)
            .then((res) => {
              this.courseSum = res.total
              this.rest = res.rest
            })
        })
      })
    })
    http['get']('students').then((res) => {
      this.students = res
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.classNum {
    width: 100%;
    height: 8rem;
    display: flex;
    justify-content: space-around;
}
.classNum img{
    width: 6rem;
    height: 6rem;
    margin: 1rem;
}
.classNumItem {
    margin: 1rem 1rem 0 0 ;
}
.classNumber {
  margin-top: 3.0rem;
  display: flex;
  justify-content: space-around;
}
.classNumber span{
  font-size: 20px;
  color: #ff0101;
}
.classNumberItem {
  display: flex;
  justify-content: center;
  align-content: center;
  margin-left: 1.5rem;
}
.classNumberItem img{
  width: 2rem;
  height: 2rem;
  margin-top: -0.4rem;
}
.centerBg {
  width: 100%;
  height: 30px;
  background: #f5f5f5;
}
.coursenum {
  display: flex;
}
.coursenum div{
  padding-right: 2rem;
}
.information {
  margin: 0.8rem;
  color: #000;
  font-size: 20px;
}
.el-divider {
  margin: 0.8rem 0 ;
}
.info {
  margin: 0.8rem;
}
.infoItem {
  display: flex;
  justify-content: space-between;
}

.time {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-left: -0.3rem;
}
.timeItem{
  width: 5.5rem;
  padding: 0.5rem 0.5rem;
  margin: 0.5rem 0.3rem;
  border: #ccc 1px solid;
  border-radius: 28px;
  text-align: center;
}
.place {
  display: flex;
  flex-wrap: wrap;
  margin-left: -0.3rem;
}
.placeItem {
  padding: 0.5rem 0.6rem;
  margin: 0.5rem 0.3rem;
  border: #ccc 1px solid;
  border-radius: 28px;
  text-align: center;
}
.student {
  margin: 0.8rem;
  border-radius: 10px;
  background: #f5f5f5;
  padding: 0.8rem;
}
.student img {
  position: absolute;
  width: 1.5rem;
  right: 0.3rem;
  margin-top: -1.5rem;
}
.addStudent {
  margin: 0.3rem;
  display: flex;
  justify-content: space-between;
}
.add {
  color: #ffb949;
}
.checked {
  color: #ffb949;
  border: solid 1px #ffb949;
}
.content {
  color: #666;
  word-break: break-all;
  word-wrap: break-word
}
.nav {
  width: 100%;
  height: 3rem;
  display: flex;
  position:fixed;
  bottom: 0;
  background: #fff;
  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.2);
}
.nav div{
    margin: 0.8rem;
    font-size: 20px;
}
.nav span {
    font-size: 20px;
    margin: 0.8rem auto 0.8rem -0.8rem;
    color: #ff0101;
}
.navUnpay {
    width: 6rem;
    margin: 0.4rem 0.8rem ;
    height: 2.2rem;
    background: rgb(182, 179, 179);
    border-radius: 44px;
    border: 0;
    color: #fff;
    font-size: 18px;
}
.navpay {
    width: 6rem;
    margin: 0.4rem 0.8rem ;
    height: 2.2rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    color: #fff;
    font-size: 18px;
}
</style>
<style>
.winClass {
  width: 60%!important;
}
</style>



// WEBPACK FOOTER //
// src/order/booking.vue